import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

/**
 * The icon bubble of a section heading: 30px, accent background, accent foreground — the look the
 * Overzicht card gives a section head (overview-card.component, Figma 1396:76013).
 *
 * It used to be a brand-alpha plate with a brand icon, a second vocabulary for one role — and one
 * that does not switch: measured in dark mode the icon stayed #a12db6, a mid purple on a near-black
 * plate, while the accent token turns #dfdfff there.
 *
 * Shared by the section card's header (`FormlyFieldPages`) and by a linked list that draws that
 * header itself (`FormlyLinkedItemsComponent`, #22553), so those two cannot drift apart. The
 * Overzicht card and the onboarding review still draw their own copy of the same bubble; moving
 * them here is a separate change.
 */
@Component({
  selector: 'app-section-icon',
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex shrink-0' },
  template: `
    <span
      class="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full bg-[var(--dd-badge-accent-bg)]">
      <mat-icon class="icon-size-4 text-[color:var(--dd-badge-accent-fg)]" [svgIcon]="icon()"></mat-icon>
    </span>
  `,
})
export class SectionIconComponent {
  readonly icon = input.required<string>();
}
